// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"410":"c6e5f741","577":"c091cb10"}[chunkId] + ".chunk.css";
};